import { InstitutionView } from "@bitwarden/web-vault/app/models/view/institution/institution.view";
import { InstitutionTableView } from "@bitwarden/web-vault/app/models/types/institution.type";
import { COUNTRIES } from "@bitwarden/web-vault/app/models/constants/global.constants";

export function getInstitutionTableViews(
  institutionViews: InstitutionView[],
): InstitutionTableView[] {
  return institutionViews?.map((instoView, index) => {
    return {
      original: instoView,
      country: COUNTRIES.find((c) => c.code === instoView.swift.countryCode)?.name,
      id: instoView.id,
      institutionCode: instoView.swift.bankCode,
      name: instoView.name,
      full_logo_url: instoView?.full_logo_url,
      square_logo_url: instoView?.square_logo_url,
      type: instoView.origin,
    } as InstitutionTableView;
  });
}
